import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAuthStore } from '@/stores/authStore'

/**
 * Landing page for the OAuth redirect from Cognito.
 *
 * Amplify automatically exchanges the ?code= query param for tokens as part
 * of library initialisation. The Hub listener in main.tsx calls initAuth()
 * when the 'signedIn' event fires, which updates isAuthenticated in the store.
 * This component watches that flag and navigates to the original destination
 * (saved in sessionStorage by AuthGuard) once auth is confirmed.
 */
export function CallbackPage() {
  const navigate = useNavigate()
  const { isAuthenticated, error } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated) {
      const destination = sessionStorage.getItem('redirectAfterAuth') ?? '/dashboard'
      sessionStorage.removeItem('redirectAfterAuth')
      navigate(destination, { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (error) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4 bg-birch-50">
        <p className="text-sm text-red-600">{error}</p>
        <button
          className="rounded-md bg-birch-600 px-4 py-2 text-sm font-semibold text-white hover:bg-birch-700"
          onClick={() => useAuthStore.getState().signIn()}
        >
          Try again
        </button>
      </div>
    )
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-birch-50">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-birch-300 border-t-birch-600" />
      <p className="text-sm text-birch-600">Completing sign in…</p>
    </div>
  )
}
